module.exports = __webpack_public_path__ + "img/undraw_icons_wdp4.1fa43871.svg";